__turbopack_context__.v({
  "actions": "AgentSupervisionWidget-module__OUdU5a__actions",
  "copy": "AgentSupervisionWidget-module__OUdU5a__copy",
  "desc": "AgentSupervisionWidget-module__OUdU5a__desc",
  "icon": "AgentSupervisionWidget-module__OUdU5a__icon",
  "layout": "AgentSupervisionWidget-module__OUdU5a__layout",
  "lead": "AgentSupervisionWidget-module__OUdU5a__lead",
  "pauseBtn": "AgentSupervisionWidget-module__OUdU5a__pauseBtn",
  "stat": "AgentSupervisionWidget-module__OUdU5a__stat",
  "statError": "AgentSupervisionWidget-module__OUdU5a__statError",
  "statLabel": "AgentSupervisionWidget-module__OUdU5a__statLabel",
  "statValue": "AgentSupervisionWidget-module__OUdU5a__statValue",
  "stats": "AgentSupervisionWidget-module__OUdU5a__stats",
  "title": "AgentSupervisionWidget-module__OUdU5a__title",
});
